import { TextV2 } from '@insights-ltd/design-library/components';
import { spacingSizeMap } from '@insights-ltd/design-library/themes';
import { styled } from '@mui/material';

const StyledDiv = styled('div')(({ theme }) => ({
  marginBottom: theme.spacing(spacingSizeMap.L),
  padding: theme.spacing(spacingSizeMap.XS),
  paddingLeft: theme.spacing(spacingSizeMap.S),
  color: theme.palette.error.main,
  background: theme.palette.error.light,
  borderRadius: '4px',
}));

export const InfoStyledDiv = styled('div')(({ theme }) => ({
  marginBottom: theme.spacing(spacingSizeMap.L),
  padding: theme.spacing(spacingSizeMap.XS),
  paddingLeft: theme.spacing(spacingSizeMap.S),
  color: theme.palette.primary.main,
  background: theme.palette.primary.light,
  borderRadius: '4px',
}));

export const CancelledStyledDiv = styled('div')(({ theme }) => ({
  padding: theme.spacing(spacingSizeMap.XS),
  paddingLeft: '1rem',
  marginBottom: theme.spacing(spacingSizeMap.L),
  '& > p': {
    color: theme.palette.error.main,
  },
  background: theme.palette.error.light,
  borderRadius: '4px',
}));

export const Notice = ({
  condition,
  text,
  Wrapper = StyledDiv,
}: {
  condition: boolean;
  text: string;
  Wrapper?: any;
}) => {
  if (!condition) return null;
  return (
    <Wrapper>
      <TextV2 variant="bodyBold">{text}</TextV2>
    </Wrapper>
  );
};
